import {JsonPlatformRestaurantAvailability} from '@deliveryhero/vendor-growth-api-client';
import {AvailabilityStateSlice} from '../slices/AvailabilityStateSlice';

export const availabilitiesReceived = (
  state: AvailabilityStateSlice,
  action: {
    payload: {
      availabilities: JsonPlatformRestaurantAvailability[] | undefined;
    };
  },
): void => {
  state.availabilities = action.payload.availabilities;
};
